import * as Yup from "yup";

export const CreateOrUpdateSurveySchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Must be 2 characters or more")
    .max(256, "Must be 256 characters or less")
    .required('Survey name must be filled in'),
});